<template>
  <section id="login">
    <v-row dense no-gutters>
      <v-col 
        cols="12" 
        lg="7"
        :hidden="$vuetify.breakpoint.mdAndDown"
      >
        <v-card
          width="100%"
          height="100vh"
          color="primary"
          class="d-flex flex-column justify-center align-center"
          tile
          flat
          dark
        >
          <div class="my-5">
            <v-img
              width="120px"
              height="auto"
              :src="require('@/assets/images/logos/logo_circle_white.png')"
            ></v-img>
          </div>
          <div class="text-h1 font-weight-medium">
            Intranet Portal
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="5">
        <v-card
          width="100%"
          height="100vh"
          color="grey lighten-4"
          class="d-flex flex-column justify-center align-center"
          tile
          flat
        >
          <v-card max-width="400px" color="transparent" flat tile>
            <v-form ref="form" @submit.prevent="resetPassword">
              <v-row>
                <v-col cols="12">
                  <div class="text-h5 grey--text font-weight-bold">
                    Reset Password
                  </div>
                  <!-- <div class="grey--text">
                            Enter your new password
                        </div> -->
                </v-col>

                <v-col v-if="message" cols="12">
                  <v-alert dense outlined type="error" dismissible>
                    {{ message }}
                  </v-alert>
                </v-col>

                <v-col cols="12" v-if="isVerified && !isChangeSuccess">
                  <v-text-field
                    v-model="newPassword"
                    outlined
                    label="New password"
                    :rules="[required, min6]"
                    :append-icon="passwordVisiable ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passwordVisiable ? 'text' : 'password'"
                    @click:append="passwordVisiable = !passwordVisiable"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" v-if="isVerified && !isChangeSuccess">
                  <v-text-field
                    v-model="newPassword2"
                    label="Confirm new password"
                    outlined
                    :rules="[required, min6, v => v === newPassword || `Passwords do not match.`]"
                    :append-icon="passwordVisiable ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passwordVisiable ? 'text' : 'password'"
                    @click:append="passwordVisiable = !passwordVisiable"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="isVerified && !isChangeSuccess">
                  <v-btn color="primary" type="submit" :loading="loading" block>
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="isChangeSuccess">
                <v-col cols="12" class="text-center">
                    <div class="success--text">You have successfully completed the password change.</div>
                </v-col>
             </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-btn class="my-2" text color="primary" block to="/auth/login">
                    <v-icon>
                      mdi-chevron-left
                    </v-icon>
                    Back to login
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import AuthService from "../../../services/auth.service";
import { convert, rules } from "@/mixins";

export default {
  name: "ResetPassword",
  async mounted() {
    await AuthService.verifyResetPasswordLink(this.userId, this.verificationId)
      .then(() => {
        this.isVerified = true;
        this.message = null;
      })
      .catch((error) => {
        this.isVerified = false;
        this.message = this.toErrorMessage(error);
      });
  },
  data() {
    return {
      userId: this.$route.query.userId,
      verificationId: this.$route.query.guid,
      isVerified: false,
      isChangeSuccess: false,
      message: null,
      newPassword: null,
      newPassword2: null,
      passwordVisiable: false,
      loading: false,
    };
  },
  methods: {
    async resetPassword() {
      this.loading = true;
      if (this.$refs.form.validate() === true) {
        await AuthService.resetPassword(this.userId, this.verificationId, this.newPassword)
          .then(() => {
            this.isChangeSuccess = true;
            this.message = null;
          })
          .catch((error) => {
            this.message = this.toErrorMessage(error);
            this.isChangeSuccess = false;
          });
      }

      this.loading = false;
    },
  },
  mixins: [convert, rules],
};
</script>
